import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InterventoPaziente } from './types/InterventoPaziente';
import { Struttura } from './types/Struttura';
import { Comune } from './types/Comune';
import { ComunePage } from './types/ComunePage';
import { environment } from '../environments/environment';
import { CotAdminUser } from './types/CotAdminUser';
import { Cot } from './types/Cot';
import { Wso2Group } from './types/Wso2Group';
import { OperationStatusPage, FhirTaskStatus } from './types/OperationStatus';
import { Distretto } from './types/Distretto';
import { TipoStruttura } from './types/TipoStruttura';
import { TipoSegnalazioneAdmin } from './types/TipoSegnalazioneAdmin';
import { QualificaReferentiOperatori } from './types/QualificaReferentiOperatori';

@Injectable({
  providedIn: 'root'
})
export class SicotService {
  API_ENDPOINT_COT_SERVICE = environment.API_ENDPOINT_COT_SERVICE;//'http://192.168.50.146:8081';
  API_ENDPOINT_COT_ADMIN = environment.API_ENDPOINT_COT_ADMIN;
  API_ENDPOINT_CONFIGURATION = environment.API_ENDPOINT_CONFIGURATION;
  API_ENDPOINT_SOGGETTO_SERVICE = environment.API_ENDPOINT_SOGGETTO_SERVICE;
  API_ENDPOINT_NOTIFICATION = environment.API_ENDPOINT_NOTIFICATION;

  private isLoggedInKey = 'isLoggedInSiCot'; // Key for login status
  private usernameKey = 'usernameKey'; // Key for username
  private userIdKey = 'userIdKey'; // Key for user id

  constructor(private http:HttpClient) {}

  login(username: string, userId: string): void {
    this.setLoginStatus(true);
    this.setUsername(username);
    this.setUserId(userId);
  }

  logout(): void {
    this.setLoginStatus(false);
    this.removeUsername();
    this.removeUserId();
  }

  isAuthenticated(): boolean {
    return this.getLoginStatus();
  }

  private setLoginStatus(status: boolean): void {
    localStorage.setItem(this.isLoggedInKey, JSON.stringify(status));
  }

  private getLoginStatus(): boolean {
    const status = localStorage.getItem(this.isLoggedInKey);
    return status ? JSON.parse(status) : false;
  }
  private setUsername(username: string): void {
    localStorage.setItem(this.usernameKey, username);
  }

  getUsername(): string | null {
    return localStorage.getItem(this.usernameKey);
  }

  private removeUsername(): void {
    localStorage.removeItem(this.usernameKey);
  }

  private setUserId(userId: string): void {
    localStorage.setItem(this.userIdKey, userId);
  }

  getUserId(): string | null {
    return localStorage.getItem(this.userIdKey);
  }

  private removeUserId(): void {
    localStorage.removeItem(this.userIdKey);
  }


   getSessioneUvm(id:any): Observable<any> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + `/sessioni-uvm/${id}`);
    }

    getEsitoUvm(id:any): Observable<any> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + `/esito-uvm/${id}`);
    }


    getOperatori(): Observable<any[]> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/operatori');
    }


    getNotifiche(): Observable<any[]> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/notifiche');
    }

    getNumeroNotificheNonLette(): Observable<any> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/num-notifiche-non-lette');
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/num-notifiche-non-lette');
    }


    getQualifiche(): Observable<any[]> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/qualifiche');
    }

    getOperatoriByQualifiche(id:any): Observable<any>{
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + `/operatori/qualifica-id/${id}`);
    }

    getStruttureByOperatori(id:any): Observable<any>{
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + `/operatore-strutture/${id}`);
    }

    getAttivita(): Observable<any[]> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/attivita');
    }

    salvainterventoPaziente(intervento: InterventoPaziente): Observable<any> {
      return this.http.post<any>(this.API_ENDPOINT_COT_SERVICE + '/save-intervento-paziente', intervento);
    }

    salvaInterventiPaziente(obj:any): Observable<any> {
      return this.http.post<any>(this.API_ENDPOINT_COT_SERVICE + '/save-interventi', obj);
    }


    getInterventiPazienteByRichiesta(id:any): Observable<any>{
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + `/intervento-paziente/${id}`);
    }

    getQualificheByCodice(codice: string): Observable<QualificaReferentiOperatori> {
      return this.http.get<QualificaReferentiOperatori>(this.API_ENDPOINT_COT_SERVICE + `/qualifiche/codice/${encodeURIComponent(codice)}`);
    }

    getAttivitaByCodice(codici: string[]): Observable<any> {
      const params = new HttpParams().set('codici', codici.join(','));
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/attivita-codice', { params });
    }

    getSetting(): Observable<any[]> {
      return this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + '/setting');
    }

  getStrutture(): Observable<Struttura[]> {
    return this.http.get<Struttura[]>(this.API_ENDPOINT_COT_SERVICE + '/strutture');
  }

  getStruttura(id: number): Observable<Struttura> {
    return this.http.get<Struttura>(this.API_ENDPOINT_COT_SERVICE + '/strutture/' + id);
  }

  getComuni(): Observable<Comune[]> {
    return this.http.get<Comune[]>(this.API_ENDPOINT_COT_SERVICE + '/comuni');
  }

  getComuniPage(page: number, size: number, search?: string, sort?: string): Observable<ComunePage> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));
    if (search != null && search.trim() !== '') {
      params = params.set('search', search.trim());
    }
    if (sort != null && sort.trim() !== '') {
      params = params.set('sort', sort.trim());
    }
    return this.http.get<ComunePage>(this.API_ENDPOINT_COT_SERVICE + '/comuni', { params });
  }

  postRichiestaValutazioneAssistito(bundle: object): Observable<unknown> {
    return this.http.post<unknown>(
      this.API_ENDPOINT_COT_SERVICE + '/richiesta-valutazione-assistito',
      bundle,
      { headers: { 'Content-Type': 'application/fhir+json' } }
    );
  }

  /** Elenco operazioni richiesta-valutazione-assistito (per admin). */
  getRichiestaValutazioneOperations(page = 0, size = 50): Observable<OperationStatusPage> {
    const params = new HttpParams().set('page', String(page)).set('size', String(size));
    return this.http.get<OperationStatusPage>(
      this.API_ENDPOINT_COT_SERVICE + '/richiesta-valutazione-assistito/operations',
      { params }
    );
  }

  /** URL per consultare lo stato di un'operazione. */
  getRichiestaValutazioneStatusUrl(operationId: string): string {
    return this.API_ENDPOINT_COT_SERVICE + '/richiesta-valutazione-assistito/status/' + encodeURIComponent(operationId);
  }

  /** GET stato operazione (FHIR Task). */
  getRichiestaValutazioneStatus(operationId: string): Observable<FhirTaskStatus> {
    return this.http.get<FhirTaskStatus>(this.getRichiestaValutazioneStatusUrl(operationId));
  }

  /** Invio esito UVM con PAI per una richiesta (admin). */
  postAdminEsitoUvmPai(body: Record<string, unknown>): Observable<unknown> {
    return this.http.post<unknown>(
      this.API_ENDPOINT_COT_SERVICE + '/admin/esito-uvm-pai',
      body,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  /** Lista utenti da cot-admin (WSO2 SCIM2). */
  getUsersCotAdmin(): Observable<CotAdminUser[]> {
    return this.http.get<CotAdminUser[]>(this.API_ENDPOINT_COT_ADMIN + '/users');
  }

  /** Crea utente in cot-admin (WSO2 SCIM2). */
  postUserCotAdmin(body: { username: string; nome?: string; cognome?: string; email?: string; password: string }): Observable<CotAdminUser> {
    return this.http.post<CotAdminUser>(this.API_ENDPOINT_COT_ADMIN + '/users', body);
  }

  /** Elenco COT da cot-admin. */
  getCots(): Observable<Cot[]> {
    return this.http.get<Cot[]>(this.API_ENDPOINT_COT_ADMIN + '/cots');
  }

  /** COT associate a un utente (wso2_user_id). */
  getUserCots(wso2UserId: string): Observable<Cot[]> {
    const params = new HttpParams().set('wso2UserId', wso2UserId);
    return this.http.get<Cot[]>(this.API_ENDPOINT_COT_ADMIN + '/user-cot', { params });
  }

  /** Imposta le COT associate a un utente. */
  setUserCots(wso2UserId: string, cotIds: number[]): Observable<void> {
    return this.http.put<void>(this.API_ENDPOINT_COT_ADMIN + '/user-cot', { wso2UserId, cotIds });
  }

  /** Elenco tipi segnalazione da cot-admin. */
  getTipiSegnalazioneAdmin(): Observable<TipoSegnalazioneAdmin[]> {
    return this.http.get<TipoSegnalazioneAdmin[]>(this.API_ENDPOINT_COT_ADMIN + '/tipo-segnalazione');
  }

  /** Tipi segnalazione associati a un utente (wso2_user_id). */
  getUserTipiSegnalazione(wso2UserId: string): Observable<TipoSegnalazioneAdmin[]> {
    const params = new HttpParams().set('wso2UserId', wso2UserId);
    return this.http.get<TipoSegnalazioneAdmin[]>(this.API_ENDPOINT_COT_ADMIN + '/user-tipo-segnalazione', { params });
  }

  /** Imposta i tipi segnalazione associati a un utente. */
  setUserTipiSegnalazione(wso2UserId: string, tipoSegnalazioneIds: number[]): Observable<void> {
    return this.http.put<void>(this.API_ENDPOINT_COT_ADMIN + '/user-tipo-segnalazione', { wso2UserId, tipoSegnalazioneIds });
  }

  /** Gruppi (ruoli) WSO2 a cui appartiene l'utente. */
  getUsersGroups(wso2UserId: string): Observable<Wso2Group[]> {
    return this.http.get<Wso2Group[]>(
      this.API_ENDPOINT_COT_ADMIN + '/users/' + encodeURIComponent(wso2UserId) + '/groups'
    );
  }

  /** Elenco distretti (cot_distretto). */
  getDistretti(): Observable<Distretto[]> {
    return this.http.get<Distretto[]>(this.API_ENDPOINT_COT_SERVICE + '/distretti');
  }

  /** Distretto per codice. */
  getDistretto(codice: number): Observable<Distretto> {
    return this.http.get<Distretto>(this.API_ENDPOINT_COT_SERVICE + '/distretti/' + codice);
  }

  /** Crea distretto. */
  createDistretto(d: Distretto): Observable<Distretto> {
    return this.http.post<Distretto>(this.API_ENDPOINT_COT_SERVICE + '/distretti', d);
  }

  /** Aggiorna distretto. */
  updateDistretto(codice: number, d: Partial<Distretto>): Observable<Distretto> {
    return this.http.put<Distretto>(this.API_ENDPOINT_COT_SERVICE + '/distretti/' + codice, d);
  }

  /** Elimina distretto. */
  deleteDistretto(codice: number): Observable<void> {
    return this.http.delete<void>(this.API_ENDPOINT_COT_SERVICE + '/distretti/' + codice);
  }

  /** Elenco tipi struttura (tipo_struttura). */
  getTipiStruttura(): Observable<TipoStruttura[]> {
    return this.http.get<TipoStruttura[]>(this.API_ENDPOINT_COT_SERVICE + '/tipo-struttura');
  }

  /** Tipo struttura per id. */
  getTipoStruttura(id: number): Observable<TipoStruttura> {
    return this.http.get<TipoStruttura>(this.API_ENDPOINT_COT_SERVICE + '/tipo-struttura/' + id);
  }

  /** Crea tipo struttura. */
  createTipoStruttura(t: TipoStruttura): Observable<TipoStruttura> {
    return this.http.post<TipoStruttura>(this.API_ENDPOINT_COT_SERVICE + '/tipo-struttura', t);
  }

  /** Aggiorna tipo struttura. */
  updateTipoStruttura(id: number, t: Partial<TipoStruttura>): Observable<TipoStruttura> {
    return this.http.put<TipoStruttura>(this.API_ENDPOINT_COT_SERVICE + '/tipo-struttura/' + id, t);
  }

  /** Elimina tipo struttura. */
  deleteTipoStruttura(id: number): Observable<void> {
    return this.http.delete<void>(this.API_ENDPOINT_COT_SERVICE + '/tipo-struttura/' + id);
  }

  /** Elenco qualifiche referenti/operatori (qualifica_referenti___operator). */
  getQualificheRefOp(): Observable<QualificaReferentiOperatori[]> {
    return this.http.get<QualificaReferentiOperatori[]>(this.API_ENDPOINT_COT_SERVICE + '/qualifiche');
  }

  /** Qualifica referenti operatori per id. */
  getQualificaRefOp(id: number): Observable<QualificaReferentiOperatori> {
    return this.http.get<QualificaReferentiOperatori>(this.API_ENDPOINT_COT_SERVICE + '/qualifiche/' + id);
  }

  /** Crea qualifica referenti operatori. */
  createQualificaRefOp(q: QualificaReferentiOperatori): Observable<QualificaReferentiOperatori> {
    return this.http.post<QualificaReferentiOperatori>(this.API_ENDPOINT_COT_SERVICE + '/qualifiche', q);
  }

  /** Aggiorna qualifica referenti operatori. */
  updateQualificaRefOp(id: number, q: Partial<QualificaReferentiOperatori>): Observable<QualificaReferentiOperatori> {
    return this.http.put<QualificaReferentiOperatori>(this.API_ENDPOINT_COT_SERVICE + '/qualifiche/' + id, q);
  }

  /** Elimina qualifica referenti operatori. */
  deleteQualificaRefOp(id: number): Observable<void> {
    return this.http.delete<void>(this.API_ENDPOINT_COT_SERVICE + '/qualifiche/' + id);
  }
}
